import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__inner inner" }
const _hoisted_3 = { class: "header__logo" }
const _hoisted_4 = {
  alt: "茶々水",
  width: "55",
  height: "28"
}

import LogoSrc from '@/assets/images/common/logo.svg'
import { homeDir } from '@/utils/define'

export default /*@__PURE__*/_defineComponent({
  __name: 'SiteHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header__ttl" }, "ブレンドティー診断", -1)),
      _createElementVNode("h1", _hoisted_3, [
        _createVNode(_component_RouterLink, { to: _unref(homeDir) }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
              [_directive_lazy, _unref(LogoSrc)]
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})